import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Gallery from './Gallery';
import { createStore } from '../../stores/contentStore';

const TemplateGalleryRoot = props => {
  const store = createStore();

  return (
    <Provider store={store}>
      <BrowserRouter>
        <Switch>
          <Route path="/templates/gallery" component={Gallery} />
        </Switch>
      </BrowserRouter>
    </Provider>
  );
};

export default props => <TemplateGalleryRoot {...props} />;
